export default {
    // Controle de tela
    currentView: 'loading', // 'loading' | 'dashboard' | 'negotiationBoticario' | 'negotiationEudora' | 'finishBoticario' | 'finishEudora' | 'notLogged'
    loading: false,
    loadingDueDate: false,
    loadingSetAgreement: false,
    loadingDashboardDebts: false,
    notLoggedText: 'Por favor, use um link de acesso válido.',

    // Dados do usuário/sessão
    docNumber: null,
    debtorId: null,
    ipUser: null,
    userAdmId: null,
    clientIdBoticario: null,
    clientIdEudora: null,
    alreadyVerified: false,

    // Dívidas e ofertas
    debtsBoticario: null,
    debtsEudora: null,
    offersBoticario: [],
    offersEudora: [],
    offersBoticarioNegotiation: [],
    offersEudoraNegotiation: [],
    mainOffersBoticario: [],
    mainOffersEudora: [],
    selectedOfferBoticario: null,
    selectedOfferEudora: null,

    // Dívida selecionada para negociação
    debtBoticario: null,

    // Datas
    lateDateBoticario: '',
    lateDateEudora: '',
    dueDateBoticario: null,
    dueDateEudora: null,
    dueDatesBoticario: [],
    dueDatesEudora: [],

    // Acordos preventivos
    preventiveBoticario: [],
    preventiveEudora: [],
    hasAgreementBoticario: false,
    hasAgreementEudora: false,
    hasNoBoticarioData: false,
    hasNoEudoraData: false,
    viewedOffersBoticarioLogKeys: [],
    viewedOffersEudoraLogKeys: [],

    // Fluxo de acordo
    agreement: null,
    prepareToSetAgreement: null,
    selectedPaymentMethod: null,

    // 2ª via / detalhes do acordo (POST agreement-installments-bill)
    /** Qual botão "2ª via" está carregando: `${brand}:${agreementId}` ou null */
    loadingAgreementBillKey: null,
    agreementBillBrand: null,
    agreementBillContextItem: null,
    agreementBillRawInner: null,
    agreementBillOptions: [],
    agreementBillSelectedOptionIndex: 0,
}
